import React, { useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { fetchFrequentQuestions } from "../../store/slices/contentSlice";
import { useDispatch, useSelector } from "react-redux";

const FrequentQuestions = ({ }) => {
    const dispatch = useDispatch();
    const { frequentQuestions } = useSelector((state) => state.content);

    useEffect(() => {
        dispatch(fetchFrequentQuestions());
    }, [])

    return (
        <div className="py-7 bg-gray-light">
            <div className="container">
                <h2 className="heading text-center text-4xl mb-4 rubik">
                    Frequently asked questions
                </h2>
                <p className="text-gray-color text-center text-lg mb-7">
                    Here are some of the common questions we receive:
                </p>
                <Accordion
                    className="w-full lg:w-8 m-auto faq-container"
                    activeIndex={0}
                    collapseIcon="pi pi-minus"
                    expandIcon="pi pi-plus"
                >
                    {frequentQuestions?.length ? frequentQuestions?.map((question, index) => (
                        <AccordionTab header={question?.question} key={index}>
                            <p className="m-0">
                                {question?.answer}
                            </p>
                        </AccordionTab>
                    )) : null}
                </Accordion>
            </div>
        </div>
    )
}

export default FrequentQuestions